export const DOCS__READING_STATUS = {
  NOT_READ: 'not_read',
  READ: 'read',
  IN_PROGRESS: 'in_progress',
  WANT_TO_READ: 'want_to_read'
} as const

export type DocsReadingStatus = (typeof DOCS__READING_STATUS)[keyof typeof DOCS__READING_STATUS]

export const DOCS_READING_STATUS_DESCRIPTIONS: Record<DocsReadingStatus, string> = {
  [DOCS__READING_STATUS.NOT_READ]: 'Nie przeczytane',
  [DOCS__READING_STATUS.READ]: 'Przeczytane',
  [DOCS__READING_STATUS.IN_PROGRESS]: 'W trakcie czytania',
  [DOCS__READING_STATUS.WANT_TO_READ]: 'Chcę przeczytać'
} as const
